namespace RedBullMOBILE360.ESim {
    export class EsimActivationCodeColumns {
        static columnsKey = 'ESim.EsimActivationCode';
    }
}